<template>
  <div id="app">
    <div v-if="(defaultHeader && !(checkExtraHealthRedirection() && this.$route.name === 'main'))">
      <!-- Check to show defaultHeader header when it is redirected-->
      <site-header />
    </div>
    <div v-if="(checkAetnaDentalAccess() && this.$route.name !== 'main')">
      <!-- Check to show athena/316 header when it is redirected-->
      <site-header />
    </div>
    <loader v-if="showLoading"></loader>
    <div class="d-flex justify-content-start" v-if="checkAgeRestrictionRender() && !(checkExtraHealthRedirection()) && !continueEnrollmentFlag && !(checkAetnaDentalAccess())">
      <age-toggle></age-toggle>
    </div>
    <div v-if="!(checkExtraHealthRedirection() && this.$route.name === 'main')" :class="{'extra-health-footer': (checkAetnaDentalAccess() && this.$route.name !== 'main')}">
      <!-- Check to show goenroll123 default footer when it is redirected-->
      <router-view/>
    </div>
    <div v-if="(defaultFooter && !(checkExtraHealthRedirection() && this.$route.name === 'main'))" :class="{'hide-footer': hideFooter}" >
      <!-- Check to show goenroll123 default footer when it is redirected-->
      <site-footer />
    </div>
    <div v-if="(checkAetnaDentalAccess() && this.$route.name == 'main')">
      <!-- Check to show 316/athena landing page when it is redirected-->
      <aetna-dental-page />
    </div>
    <div v-if="(checkAetnaDentalAccess() && this.$route.name !== 'main')">
      <!-- Check to show 316/athena footer when it is redirected-->
      <GoenrollFooter :goToSection="goToSection" />
    </div>
    <div v-if="(checkExtraHealthRedirection() && this.$route.name === 'main')">
      <!-- Check is for redirection to extra health plan listing page      -->
      <ExtrahealthLandingPage />
    </div>
    <location-permission />
    <notifications></notifications>
  </div>
</template>

<script>
import SiteHeader from './components/SiteHeader.vue'
import SiteFooter from './components/SiteFooter.vue'
import loader from './components/LoaderGlobal.vue'
import LocationPermission from './components/LocationPermission.vue'
import AgeToggle from "./components/AgeToggle.vue";
import { mapState } from 'vuex';
import {checkFarmerSiteRedirection} from "./utils/Helper";
import {checkExtraHealthGroup, checkAetnaDentalAccess} from "./utils/checkPlatform";
import AetnaDentalPage from "./views/AetnaDentalLanding/AetnaDentalPage";
import GoenrollFooter from "@/components/Aetna/GonerollFooter/GoenrollFooter.vue";
import {siteDomainUrlSpanish} from "./config/config";
import ExtrahealthLandingPage from "./views/ExtraHealthLanding/ExtrahealthLandingPage";
export default {
  components: {
    SiteHeader,
    SiteFooter,
    loader,
    LocationPermission,
    AgeToggle,
    AetnaDentalPage,
    GoenrollFooter,
    ExtrahealthLandingPage
  },
  mounted () {
    this.FetchColorCodeInfo();
    this.checkAndSetSpanishTranslation('googtrans');
    this.renderFavIcon();
    this.disableGoogleTranslate();
    this.platformType = window.localStorage.getItem('platformType');
  },
  data(){
    return{
      defaultHeader: true,
      defaultFooter: true,
      hideFooter: false,
      platformType: ''
    }
  },
  methods: {
    checkAndSetSpanishTranslation (name) {
      let app = this
      const domain = window.location.hostname.replace('www.', '');
      console.log('domain', domain, siteDomainUrlSpanish)
      if ((domain === siteDomainUrlSpanish) || (app.landingUrl === '316sp')) {
        document.cookie =`${name}=/en/es; path=/; domain=${domain}`;
        document.cookie =`${name}=/en/es;  path=/; domain=.${domain}`;
        document.cookie =`${name}=/en/es;  path=/; domain=.corenroll.com`;
        document.cookie =`${name}=/en/es;  path=/; domain=.goenroll123.com`;
        console.log('document.cookie spain',  document.cookie)
        app.removeGoogleTranslateBar();
      } else {
        document.cookie =`${name}=;  path=/; domain=${domain}`;
        document.cookie =`${name}=;  path=/; domain=.${domain}`;
        document.cookie =`${name}=;  path=/; domain=.corenroll.com`;
        console.log('document.cookie english',  document.cookie)
      }
    },
    removeGoogleTranslateBar () {
      const elements = ['#google_translate_element', '.skiptranslate',
        '.goog-te-banner-frame',
        '.goog-te-menu-frame'];
      elements.forEach(selector => {
        const el = document.querySelector(selector)
        if (el) el.remove();
      })
      document.body.style.top = '0';
    },
    FetchColorCodeInfo () {
      console.log('*** FetchColorCode ***')
      // let siteDomain = window.btoa(unescape(encodeURIComponent('https://enroll.purenroll.com')))
      let siteDomain = window.btoa(unescape(encodeURIComponent(process.env.VUE_APP_SITE_DOMAIN)))
      // let siteDomain = 'aHR0cHM6Ly9lbnJvbGwucHVyZW5yb2xsLmNvbQ=='
      let url = `${process.env.VUE_APP_API_BASE}/get-external-site-dynamic-information?site_domain=${siteDomain}`
      // passing request object
      let req = new Request(url, {
        method: 'GET',
        headers: {
          'Content-Type': process.env.VUE_APP_CONTENT_TYPE,
          'Authorization': process.env.VUE_APP_AUTHORIZATION
        },
        mode: 'cors'
      })
      // Using fetch api javascript in built library for api req
      fetch(req)
          .then(response => {
            response.json().then(data => {
              // this.getCatchColor = JSON.stringify(data.data)
              // console.log('fetch response', JSON.stringify(data.data))

              // Creating cache name fetch_color_cache
              caches.open('fetch_color_cache').then((cache) => {
                // Converting response send as promise to Json object.
                const jsonResponse = new Response(JSON.stringify(data.data));
                // Storing the response on created catch
                cache.put(req, jsonResponse);
              }).catch((err) => {
                console.log(err);
              })

            })
          })
          .catch(error => {
            console.log(error);
          });
    },
    renderFavIcon() {
      if (process.env.VUE_APP_IS_GO_ENROLL == 'true') {
        let favicon = document.getElementById("favicon");
        favicon.href = 'goenroll-fav.ico'
        document.title = 'GO ENROLL 123'
      } else {
        let favicon = document.getElementById("favicon");
        favicon.href = 'favicon.png'
        document.title = 'Easiest Enrollment System - Corenroll'
      }
    },
    disableGoogleTranslate () {
     if (process.env.VUE_APP_IS_GO_ENROLL == 'false') {
       let element = document.getElementById('google_translate_element');
       element.style.display = 'none'
     }
    },
    checkAgeValidCondition () {
      let app = this
      return checkFarmerSiteRedirection(app.landingInfo,  app.employeeGroupCode);
    },
    checkAgeRestrictionRender () {
      if (this.platformType == 'rep-quote') {
        return false
      } else if (this.$store.getters.isRepAuthenticated && this.$route.name !== 'AccessPage' && this.$route.name !== 'GroupHomeOption' && !this.checkAgeValidCondition()) {
        return true
      } else {
        return false
      }
    },
    checkExtraHealthRedirection () {
      let app = this
      return (checkExtraHealthGroup(app.landingInfo))
    },
    checkAetnaDentalAccess () {
      let app = this
      return (checkAetnaDentalAccess(app.landingInfo))
    },
    goToSection(page, sectionId) {
      if (this.$route.name === '361-information') {
        if (this.$route.path !== page) {
          this.$router.push({ path: page, hash: `#${sectionId}` }).then(() => {
            this.scrollToSection(sectionId);
          });
        } else {
          this.scrollToSection(sectionId);
        }
      } else {
        window.open(`${page}#${sectionId}`, "_blank");
        this.scrollToSection(sectionId);
      }
    },
    scrollToSection(sectionId) {
      this.$nextTick(() => {
        const el = document.getElementById(sectionId);
        if (el) el.scrollIntoView({ behavior: "smooth" });
      });
    },
  },
  watch: {
    "$route.params": {
      handler() {
        if (this.$route.name == "error" || this.$route.name == 'decline-reminder-email' || this.$route.name == "landing-config-error" ||  (this.checkAetnaDentalAccess())) {
          this.defaultHeader = false;
          this.defaultFooter = false;
        } else if ( this.$route.name == 'GroupHomeOption') {
          this.defaultHeader = false;
          this.hideFooter = true;
        } else if (this.$route.name === 'AccessPage') {
          this.defaultHeader = false;
          this.defaultFooter = false;
        } else {
          this.defaultHeader = true;
          this.defaultFooter = true;
          this.hideFooter = false;
        }
      },
      immediate: true,
    },
  },
  computed: {
    ...mapState({
      showLoading: state => state.showLoading
    }),
    landingInfo() {
      return this.$store.getters.getLandingInfo
    },
    employeeGroupCode () {
      return this.$store.getters.getEmployeeGroupCode
    },
    continueEnrollmentFlag () {
      return this.$store.getters.getContinueEnrollmentFlagState
    },
    landingUrl() {
      return this.$store.getters.getLandingUrl
    }
  }
}
</script>

<style>
@import url('assets/fonts/stylesheet.css');
@import url('assets/css/common.css');
#app {
  font-family: 'Raleway' !important;
}
body{
  background-color: #f3f8fa !important;
  position: relative;
}
body::before{
  content: '';
  position: absolute;
  background: url(./assets/body-bg.png) no-repeat;
  width: 100%;
  height: 100%;
  background-size: inherit;
  min-height: 100vh;
  background-position: right top;
  z-index: -1;
  background-attachment: fixed;
}
a, a:hover{
  color: inherit;
  text-decoration: none !important;
}

.hide-footer {
  display: none;
}
</style>

<style lang="scss" >
    //#app {
    //    font-family: Avenir, Helvetica, Arial, sans-serif;
    //    -webkit-font-smoothing: antialiased;
    //    -moz-osx-font-smoothing: grayscale;
    //    text-align: center;
    //    color: #2c3e50;
    //}
    // @import "css/common.css";
    // @import "css/index.css";
    /*@import "css/main.css";*/
    //@import "css/plan_desc.css";
    //@import "scss/main";

    // @import "assets/scss/main.scss";
    .vue-notifyjs {
      .alert {
        z-index: 1080 !important;
        &.alert-with-icon {
          padding-left: 25px !important;
        }
        .alert-icon {
          margin-right: 15px !important;
        }
        .close ~ span {
          display: inline-block !important;
        }
      }
    }

.extra-health-footer {
   min-height: 90vh;
 }

/* Google translate class to hide its feature on spanish translation */
.VIpgJd-ZVi9od-ORHb-OEVmcd {
 visibility: hidden !important;
}

.VIpgJd-ZVi9od-aZ2wEe-wOHMyf-ti6hGc {
  display: none !important;
  visibility: hidden !important;
}

body {
  top: 0 !important;
}
</style>
